

// import React, { useEffect, useState } from "react";
// import "../Styles/Home.css";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Container, Button, Row, Col, Form,Table } from "react-bootstrap";
// import Navbar1 from "./Navbar";
// import Header from "./Header";

// function Viewdet() {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const { patientData } = location.state || {};
//     const [recommendation, setRecommendation] = useState(null);

//     const [formData, setFormData] = useState({
//         diabetesType: "",
//         height: "",
//         weight: "",
//         age:"",
//         gender:"",
//         bmi: "",
//         hba1c: "",
//         fastingGlucose: "",
//         postprandialGlucose: "",
//         insulin: {},
//         recom: ""
//     });

    
//     useEffect(() => {
//         if (Array.isArray(patientData) && patientData.length > 0) {
//             try {
//                 console.log("Raw patientData:", patientData);
    
            
    
//                 // Assuming you want to update the form with the first entry in the array
//                 const firstEntry = patientData[0];
    
//                 const updatedFormData = {
//                     diabetesType: "Type " + firstEntry.type,
//                     height: firstEntry.metrics?.height || "",
//                     weight: firstEntry.metrics?.weight || "",
//                     age: firstEntry.dd.age || "",
//                     gender: firstEntry.dd?.gender || "",
//                     bmi: firstEntry.metrics?.bmi || "",
//                     hba1c: firstEntry.tests?.a1c || "",
//                     fastingGlucose: firstEntry.tests?.fs || "",
//                     postprandialGlucose: firstEntry.tests?.pp || "",
//                     insulin: firstEntry.dd.insulin || {},
//                     recom: firstEntry.ba || "",
//                     duration: firstEntry.dur || ""
//                 };
//     console.log("check",updatedFormData.insulin);
//                 setFormData(updatedFormData);

//                 if (firstEntry.type === 2 && firstEntry.dd) {
//                     setRecommendation(firstEntry.dd);
//                 }
                
//                 console.log("fd", updatedFormData);
//             } catch (error) {
//                 console.error("Error processing patient details:", error);
//             }
//         }
//     }, [patientData]);
    
//     return (
//         <>
//             <Header />
//             <Navbar1 />
//             <Container className="px-2">
//                 <Row className="justify-content-center">
//                     <Col lg={7} md={8} xs={12}>
//                         <Button variant="danger" onClick={() => navigate("/view")} className="mb-3">
//                             ← Back to View
//                         </Button>
//                         <div className="card shadow">
//                             <div className="card-header text-white">
//                                 <h1 className="h4 mb-0">Patient Details</h1>
//                             </div>
//                             <div className="card-body">
//                                 <Form>
//                                     <Row>
//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Diabetes Type</Form.Label>
//                                                 <Form.Control type="text" value={formData.diabetesType} readOnly />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Diabetes Durations</Form.Label>
//                                                 <Form.Control type="text"  value={formData.duration ? `${formData.duration} ${formData.duration > 1 ? 'years' : 'year'}` : ""}  readOnly />
//                                             </Form.Group>
//                                         </Col>


//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Height (Cm)</Form.Label>
//                                                 <Form.Control type="text" value={formData.height} readOnly />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Weight (Kg)</Form.Label>
//                                                 <Form.Control type="text" value={formData.weight} readOnly />
//                                             </Form.Group>
//                                         </Col>


//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Age</Form.Label>
//                                                 <Form.Control type="text" value={formData.age} readOnly />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Gender</Form.Label>
//                                                 <Form.Control type="text" value={formData.gender} readOnly />
//                                             </Form.Group>
//                                         </Col>

                    
//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>BMI</Form.Label>
//                                                 <Form.Control type="text" value={formData.bmi} readOnly />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>HbA1c (%)</Form.Label>
//                                                 <Form.Control type="text" value={formData.hba1c} readOnly />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Fasting Glucose (mg/dL)</Form.Label>
//                                                 <Form.Control type="text" value={formData.fastingGlucose} readOnly />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col lg={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>Postprandial Glucose (mg/dL)</Form.Label>
//                                                 <Form.Control type="text" value={formData.postprandialGlucose} readOnly />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>

//                                     {/* {formData.diabetesType === "Type 1" ? (
//                                         formData.insulin && Object.keys(formData.insulin).length > 0 && (
//                                             <div className="mt-4">
//                                                 <h4 className="border-bottom pb-2">Results</h4>
//                                                 <p style={{color:"red"}}><strong>Total Insulin Requirement: {formData.insulin.totalInsulin || ""} units</strong></p>
//                                                 <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin || ""} units</p>
//                                                 <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin || ""} units</p>
//                                                 <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin || ""} units</p>
//                                                 <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin || ""} units</p>
//                                             </div>
//                                         )
//                                     ) : (
//                                         <div className="mt-4">
//                                             <h4 className="border-bottom pb-2">Results</h4>
//                                             <p><strong>Weight:</strong> {formData.weight || "N/A"} Kg</p>
//                                         </div>
//                                     )} */}

// <div id="results" className="mt-4">
//     <h4 className="border-bottom pb-2 text-center text-primary">Results</h4>

//     {/* Type 1 Diabetes - Insulin Calculation Results */}
//     {formData.diabetesType === "Type 1" && formData.insulin && (
//                                             <div className="mt-4">
//                                                 <p style={{ color: "red" }}>
//                                                     <strong>Total Insulin Requirement: {formData.insulin.totalInsulin} units</strong>
//                                                 </p>
//                                                 <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin || "0"} units</p>
//                                                 <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin || "0"} units</p>
//                                                 <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin || "0"} units</p>
//                                                 <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin || "0"} units</p>
//                                             </div>
//                                         )}

//     {/* Type 2 Diabetes - CDSS Recommendations */}
//     {recommendation && (
//         <>
//             <p>
//                 <strong>Comments:</strong> {recommendation.CDSS_OUTPUT?.comments || "No comments available."}
//             </p>
//             <p>
//                 <strong>Note:</strong> {recommendation.CDSS_OUTPUT?.NOTE || "No additional notes."}
//             </p>

//             {recommendation?.CDSS_OUTPUT?.RecommendedTherapy &&
// Object.keys(recommendation.CDSS_OUTPUT.RecommendedTherapy).length > 0 && (
//     <>
//         <h4 className="border-bottom pb-2 text-center text-primary">Recommendation</h4>
//         <ul>
//             {Object.values(recommendation.CDSS_OUTPUT.RecommendedTherapy)
//                 .slice(0, 5)
//                 .map((therapy, index) => (
//                      <li key={index}>
//                     <strong>
//                     {typeof therapy === "object" && therapy.InsulinType
//                       ? `Insulin Type: ${therapy.InsulinType}`
//                       : therapy}
//                   </strong>
//                      </li>
//                 ))}
//         </ul>
//     </>
// )}

//             {/* Drug Preferences Table */}
//             {recommendation.GBTM_OUTPUT && recommendation.GBTM_OUTPUT[0]?.DRUG_COMBINATION && (
//                 <>
//                     <h4 className="border-bottom pb-2 text-center text-primary">Preferences</h4>
//                     <Table className="mb-5">
//                         <thead className="table-header">
//                             <tr>
//                                 <th>Preference</th>
//                                 <th>Importance</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION.map((drug, index) => (
//                                 <tr key={index}>
//                                     {Object.entries(drug).map(([key, value]) => (
//                                         <td key={key}>{value}</td>
//                                     ))}
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </>
//             )}
//         </>
//     )}
// </div>
//                                 </Form>
//                             </div>
//                         </div>
//                     </Col>
//                 </Row>
//             </Container>
//         </>
//     );
// }

// export default Viewdet;


import React, { useEffect, useState } from "react";
import "../Styles/Home.css";
import { useNavigate, useLocation } from "react-router-dom";
// 1. IMPORT MODAL HERE
import { Container, Button, Row, Col, Form, Table, Modal } from "react-bootstrap";
import Navbar1 from "./Navbar";
import Header from "./Header";

function Viewdet() {
    const navigate = useNavigate();
    const location = useLocation();
    const { patientData } = location.state || {};
    const [recommendation, setRecommendation] = useState(null);
    
    // 2. ADD STATE FOR CLINICAL MODAL
    const [showClinicalModal, setShowClinicalModal] = useState(false);

    const [formData, setFormData] = useState({
        diabetesType: "",
        height: "",
        weight: "",
        age:"",
        gender:"",
        bmi: "",
        hba1c: "",
        fastingGlucose: "",
        postprandialGlucose: "",
        insulin: {},
        recom: ""
    });

    useEffect(() => {
        if (Array.isArray(patientData) && patientData.length > 0) {
            try {
                console.log("Raw patientData:", patientData);
    
                // Assuming you want to update the form with the first entry in the array
                const firstEntry = patientData[0];
    
                const updatedFormData = {
                    diabetesType: "Type " + firstEntry.type,
                    height: firstEntry.metrics?.height || "",
                    weight: firstEntry.metrics?.weight || "",
                    age: firstEntry.dd.age || "",
                    gender: firstEntry.dd?.gender || "",
                    bmi: firstEntry.metrics?.bmi || "",
                    hba1c: firstEntry.tests?.a1c || "",
                    fastingGlucose: firstEntry.tests?.fs || "",
                    postprandialGlucose: firstEntry.tests?.pp || "",
                    insulin: firstEntry.dd.insulin || {},
                    recom: firstEntry.ba || "",
                    duration: firstEntry.dur || ""
                };
                console.log("check", updatedFormData.insulin);
                setFormData(updatedFormData);

                if (firstEntry.type === 2 && firstEntry.dd) {
                    setRecommendation(firstEntry.dd);
                }
                
                console.log("fd", updatedFormData);
            } catch (error) {
                console.error("Error processing patient details:", error);
            }
        }
    }, [patientData]);
    
    return (
        <>
            <Header />
            <Navbar1 />
            <Container className="px-2">
                <Row className="justify-content-center">
                    <Col lg={7} md={8} xs={12}>
                        <Button variant="danger" onClick={() => navigate("/view")} className="mb-3">
                            ← Back to View
                        </Button>
                        <div className="card shadow">
                            <div className="card-header text-white">
                                <h1 className="h4 mb-0">Patient Details</h1>
                            </div>
                            <div className="card-body">
                                <Form>
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Diabetes Type</Form.Label>
                                                <Form.Control type="text" value={formData.diabetesType} readOnly />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Diabetes Durations</Form.Label>
                                                <Form.Control type="text"  value={formData.duration ? `${formData.duration} ${formData.duration > 1 ? 'years' : 'year'}` : ""}  readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Height (Cm)</Form.Label>
                                                <Form.Control type="text" value={formData.height} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Weight (Kg)</Form.Label>
                                                <Form.Control type="text" value={formData.weight} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Age</Form.Label>
                                                <Form.Control type="text" value={formData.age} readOnly />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Gender</Form.Label>
                                                <Form.Control type="text" value={formData.gender} readOnly />
                                            </Form.Group>
                                        </Col>
                    
                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>BMI</Form.Label>
                                                <Form.Control type="text" value={formData.bmi} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>HbA1c (%)</Form.Label>
                                                <Form.Control type="text" value={formData.hba1c} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Fasting Glucose (mg/dL)</Form.Label>
                                                <Form.Control type="text" value={formData.fastingGlucose} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Postprandial Glucose (mg/dL)</Form.Label>
                                                <Form.Control type="text" value={formData.postprandialGlucose} readOnly />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <div id="results" className="mt-4">
                                        <h4 className="border-bottom pb-2 text-center text-primary">Results</h4>

                                        {/* Type 1 Diabetes - Insulin Calculation Results */}
                                        {formData.diabetesType === "Type 1" && formData.insulin && (
                                            <div className="mt-4">
                                                <p style={{ color: "red" }}>
                                                    <strong>Total Insulin Requirement: {formData.insulin.totalInsulin} units</strong>
                                                </p>
                                                <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin || "0"} units</p>
                                                <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin || "0"} units</p>
                                                <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin || "0"} units</p>
                                                <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin || "0"} units</p>
                                            </div>
                                        )}

                                        {/* Type 2 Diabetes - CDSS Recommendations */}
                                        {recommendation && (
                                            <>
                                                <p>
                                                    <strong>Comments:</strong> {recommendation.CDSS_OUTPUT?.comments || "No comments available."}
                                                </p>
                                                <p>
                                                    <strong>Note:</strong> {recommendation.CDSS_OUTPUT?.NOTE || "No additional notes."}
                                                </p>
                                                {/* 3. ADDED BUTTON TO TRIGGER MODAL */}
                                                {recommendation.suggested_drug_check && (
                                                    <div className="text-center mt-4 mb-5">
                                                        <Button 
                                                            variant="info" 
                                                            className="px-4 py-2" 
                                                            style={{ backgroundColor: "#6200ea", borderColor: "#6200ea", color: "white" }}
                                                            onClick={() => setShowClinicalModal(true)}
                                                        > 
                                                         Details
                                                        </Button>
                                                    </div>
                                                )}
                                                {recommendation?.CDSS_OUTPUT?.RecommendedTherapy &&
                                                Object.keys(recommendation.CDSS_OUTPUT.RecommendedTherapy).length > 0 && (
                                                    <>
                                                        <h4 className="border-bottom pb-2 text-center text-primary">Recommendation</h4>
                                                        <ul>
                                                            {Object.values(recommendation.CDSS_OUTPUT.RecommendedTherapy)
                                                                .slice(0, 5)
                                                                .map((therapy, index) => (
                                                                     <li key={index}>
                                                                    <strong>
                                                                    {typeof therapy === "object" && therapy.InsulinType
                                                                      ? `Insulin Type: ${therapy.InsulinType}`
                                                                      : therapy}
                                                                  </strong>
                                                                     </li>
                                                                ))}
                                                        </ul>
                                                    </>
                                                )}

                                                {/* Drug Preferences Table */}
                                                {recommendation.GBTM_OUTPUT && recommendation.GBTM_OUTPUT[0]?.DRUG_COMBINATION && (
                                                    <>
                                                        <h4 className="border-bottom pb-2 text-center text-primary">Preferences</h4>
                                                        <Table className="mb-5">
                                                            <thead className="table-header">
                                                                <tr>
                                                                    <th>Preference</th>
                                                                    <th>Importance</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION.map((drug, index) => (
                                                                    <tr key={index}>
                                                                        {Object.entries(drug).map(([key, value]) => (
                                                                            <td key={key}>{value}</td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </>
                                                )}


                                            </>
                                        )}
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
                
                {/* 4. ADDED THE CLINICAL DETAILS MODAL */}
                <Modal show={showClinicalModal} onHide={() => setShowClinicalModal(false)} size="lg" scrollable>
                    <Modal.Header closeButton className="bg-light">
                        <Modal.Title className="text-primary">Suggested Drug Check Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {recommendation?.suggested_drug_check && (
                            <>
                                {/* Patient Baseline Risk Assessment */}
                                <h6 className="text-secondary border-bottom pb-1">Patient Baseline Risk Assessment</h6>
                                <p><strong>Vitals & Labs Analysis:</strong> {recommendation.suggested_drug_check.patient_baseline_risk_assessment?.vitals_and_labs_analysis}</p>
                                <p><strong>Baseline Therapy Evaluation:</strong> {recommendation.suggested_drug_check.patient_baseline_risk_assessment?.baseline_therapy_evaluation}</p>

                                {/* Clinical Rationale */}
                                <h6 className="text-secondary border-bottom pb-1 mt-4">Clinical Rationale</h6>
                                <p><strong>Justification:</strong> {recommendation.suggested_drug_check.suggested_drug_clinical_rationale?.clinical_justification_why}</p>

                                {/* Mechanism of Action */}
                                <h6 className="text-secondary border-bottom pb-1 mt-4">Mechanism of Action & Benefits</h6>
                                <p><strong>How it Works:</strong> {recommendation.suggested_drug_check.mechanism_action?.mechanism_of_action_how}</p>
                                <p><strong>Therapeutic Benefits:</strong> {recommendation.suggested_drug_check.mechanism_action?.therapeutic_benefits_and_recovery}</p>

                                {/* Breakdown and Tradeoffs */}
                                {recommendation.suggested_drug_check.suggested_options_breakdown_and_tradeoffs && (
                                    <>
                                        <h6 className="text-secondary border-bottom pb-1 mt-4">Options Breakdown & Tradeoffs</h6>
                                        {recommendation.suggested_drug_check.suggested_options_breakdown_and_tradeoffs.map((option, index) => (
                                            <div key={index} className="mb-3 p-3 bg-light rounded">
                                                <p className="mb-1"><strong>Drug:</strong> {option.suggested_option_name}</p>
                                                <p className="mb-1"><strong>Effectiveness:</strong> {option.clinical_effectiveness}</p>
                                                <p className="mb-1 text-success"><strong>Pros:</strong> {option.pros_and_benefits}</p>
                                                <p className="mb-0 text-danger"><strong>Cons/Precautions:</strong> {option.cons_and_precautions}</p>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowClinicalModal(false)}>Close</Button>
                    </Modal.Footer>
                </Modal>

            </Container>
        </>
    );
}

export default Viewdet;
